import { createFileRoute, Link } from "@tanstack/react-router";
import { CheckCircle2, Home, MessageCircle } from "lucide-react";
import { buildWhatsAppUrl } from "@/lib/whatsapp";

export const Route = createFileRoute("/business-signup_/thanks")({
  head: () => ({
    meta: [
      { title: "Thank you — Bacha Way Travel" },
      { name: "description", content: "Your B2B partnership request has been received." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: ThanksPage,
});

function ThanksPage() {
  const waUrl = buildWhatsAppUrl(
    "Hello Bacha Way Travel, I just submitted a B2B partnership request. I'd like to follow up."
  );

  return (
    <section className="bg-background">
      <div className="mx-auto max-w-2xl px-6 py-20 md:py-28 text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary">
          <CheckCircle2 className="h-9 w-9" />
        </div>
        <h1 className="mt-6 text-3xl md:text-5xl font-bold leading-tight">
          Thank you for trusting in Bacha Way
        </h1>
        <p className="mt-4 text-muted-foreground text-lg">
          Our business relationship manager will contact you soon.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground hover:opacity-90 transition"
          >
            <Home className="h-4 w-4" /> Home
          </Link>
          <a
            href={waUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-semibold text-white hover:opacity-90 transition"
          >
            <MessageCircle className="h-4 w-4" /> WhatsApp contact
          </a>
        </div>
      </div>
    </section>
  );
}
